import React from "react";

export default function About() {
  return (
    <p>
        Nora is an Episcopal priest working and living in Iowa City, IA.
    </p>
  );
}
